import { Injectable } from '@angular/core';
import {  Response, Headers, ResponseContentType, RequestMethod } from '@angular/http';
 
import "rxjs/add/operator/map"
import { Observable } from 'rxjs/Observable';
  
 import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
 
import { Client } from '../entity/exhibitor';
import { Hebergement } from '../entity/hebergement';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class LogistiqueService {
 
  private baseUrl: string = environment.restApi;
  constructor( private http:HttpClient ) {

 
}
getAllHebergements(): Observable<Hebergement[]> {
  const hebergement$ = this.http
    .get<Hebergement[]>(`${this.baseUrl}` + 'hebergement', httpOptions);
  return hebergement$;
}
uploadFile(file: FormData,fileName:string,hebergId:number): Observable<Response> {
 

  return this.http.post<any>(`${this.baseUrl}hebergement/upload/${hebergId}/${fileName}`, file);
}

showFile(hebergement: Hebergement,type:string): any {

  let pjoint$ =  this.http.get(`${this.baseUrl}hebergement/showFile/${hebergement.id_hebergement}/${type}`  , { responseType: "blob"})  ;
  return pjoint$;
}
editHebergement(hebergement: Hebergement): Observable<Hebergement > {
  return  this.http.put<Hebergement>(`${this.baseUrl}hebergement/${hebergement.id_hebergement}`, hebergement);
}
addHebergement(hebergement: Hebergement) : Observable<Hebergement >{
return   this.http.post<Hebergement>(`${this.baseUrl}hebergement`, hebergement);
}
removeHebergement(hebergement: Hebergement) : Observable<Hebergement >{
  return   this.http.delete<Hebergement>(`${this.baseUrl}hebergement/${hebergement.id_hebergement}` );
   }
 
  
  private getHeaders1() {
    const headers = new Headers();
    headers.append('Accept', 'application/pdf');
    headers.append('Content-Type', 'application/pdf');
    return headers;
  }


}

 
 

 